import { PostHogProvider as OriginalProvider } from 'posthog-js/react';
import type { PropsWithChildren } from 'react';
import type { PostHogConfig } from 'posthog-js';
import { dropBotNoiseExceptions } from './dropBotNoiseExceptions';

const isDev = import.meta.env.DEV;
const apiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;

const tracingDomain = window.location.hostname.includes('staging')
  ? 'app.staging.torquetitan.ai'
  : 'app.torquetitan.ai';

const options: Partial<PostHogConfig> = {
  // PostHog managed reverse proxy — first-party domain so events survive ad blockers.
  api_host: 'https://p.torquetitan.ai',
  defaults: '2025-05-24',
  __add_tracing_headers: [tracingDomain],
  before_send: dropBotNoiseExceptions,
  session_recording: {
    // Record input values in replays; only password fields stay masked.
    maskAllInputs: false,
    maskInputOptions: {
      password: true,
    },
  },
};

export const PostHogProvider = ({ children }: PropsWithChildren) => {
  // Skip PostHog in dev, or on any build where the key was intentionally
  // omitted (no VITE_PUBLIC_POSTHOG_KEY) — e.g. local dev and CI E2E — so
  // synthetic traffic doesn't pollute the staging project.
  if (isDev || !apiKey) {
    return <>{children}</>;
  }

  return (
    <OriginalProvider apiKey={apiKey} options={options}>
      {children}
    </OriginalProvider>
  );
};
